import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { ExceptionsAccordionProps } from "./types";
import { DeviceErrorMessage } from "../../../../models/Device";

export default function ExceptionsAccordion(props: ExceptionsAccordionProps) {
	const { exceptions, label } = props;

	return (
		<Accordion>
			<AccordionSummary
				expandIcon={<ArrowDownwardIcon />}
				aria-controls='panel1-content'
				sx={{ display: "flex", justifyContent: "space-between" }}
				id='panel1-header'>
				<Typography color={"error"}>{label}</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{exceptions.map((exception, index) => {
					return (
						<Typography
							key={index}
							variant='body2'
							component='p'
							justifyContent={"flex-start"}
							textAlign={"justify"}>
							{DeviceErrorMessage[exception]}
						</Typography>
					);
				})}
			</AccordionDetails>
		</Accordion>
	);
}
